import React, { useEffect, useState } from 'react';
import API from 'api';
import { connect } from 'react-redux';

import { filesURL } from 'config';
import classes from './CharacterAnimation.module.scss';

const IMG_PREFIX = 'Images/SuccessAnimations/';

const CharacterAnimation = ({
  game,
  onFinish,
  onReady,
  onError,
  duration = 6000,
}) => {
  const [src, setSrc] = useState('');

  useEffect(() => {
    const init = async () => {
      const randomNum = Math.floor(Math.random() * 7) + 1;
      const fileName = `${randomNum}.gif`;
      const fullPath = IMG_PREFIX + fileName;

      try {
        const exists = await API.storage.checkIfFileExists(fullPath);

        if (exists) {
          setSrc(fullPath);

          onReady?.();

          setTimeout(() => {
            onFinish?.();
          }, duration);

          return;
        }

        onError?.();
      } catch (err) {
        console.error('Animation check error:', err);
        onError?.();
      }
    };

    init();
  }, [onFinish, onReady, onError, duration]);

  if (!src) return null;

  return (
    <div className={classes.wrapper}>
      <img src={`${filesURL}/${src}`} alt="success animation" />
    </div>
  );
};

const mapStateToProps = ({ game }) => ({ game });

export default connect(mapStateToProps)(CharacterAnimation);